"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockedSdk = void 0;
var mockedData_1 = require("./mockedData");
var MockedSdk = (function () {
    function MockedSdk() {
    }
    MockedSdk.prototype.getJWT = function () {
        return mockedData_1.mockedJWTToken;
    };
    MockedSdk.prototype.getUser = function () {
        return mockedData_1.mockedUser;
    };
    MockedSdk.prototype.getBrand = function () {
        return mockedData_1.mockedBrand;
    };
    MockedSdk.prototype.getTheme = function () {
        return mockedData_1.mockedTheme;
    };
    MockedSdk.prototype.getInitialRoute = function () {
        return mockedData_1.mockedInitialRoute;
    };
    MockedSdk.prototype.init = function () {
        return {
            user: this.getUser(),
            building: this.getBuilding(),
            base_url: mockedData_1.base_url,
            session_token: mockedData_1.sessionToken,
            jwt_token: this.getJWT(),
            theme: this.getTheme(),
            brand: this.getBrand(),
            initial_route: this.getInitialRoute(),
        };
    };
    MockedSdk.prototype.getBuilding = function () {
        return mockedData_1.mockedBuilding;
    };
    MockedSdk.prototype.getHostInfo = function () {
        return mockedData_1.mockedHostInfo;
    };
    MockedSdk.prototype.getTokenizeCard = function () {
        return mockedData_1.mockedGetTokenizeCard;
    };
    MockedSdk.prototype.getBuildings = function () {
        return [this.getBuilding()];
    };
    return MockedSdk;
}());
exports.MockedSdk = MockedSdk;
//# sourceMappingURL=mockedSdk.js.map